/**
 * What the app calls itself on the About rows.
 *
 * One constant because three places print it — the hub's About row, the Help
 * page's Web version row and its About panel — and V1 had the string typed out
 * twice already. Not read from `package.json`: that is a build-time file the
 * app does not import, and wiring a `define` for a version nobody releases
 * against yet would be ceremony. When there is a release pipeline, this is the
 * single line it writes.
 */
export const APP_VERSION = '1.0.0'
